/** A step that took longer than allowed; `step` says which (shown in the error, for finding the cause). */
export class StepTimeoutError extends Error {
  constructor(public step: string) {
    super(`Timed out: ${step}`);
    this.name = 'StepTimeoutError';
  }
}

/**
 * Gives up on `promise` after `ms` (2026-10-17: a photo on Jens's iPhone hung somewhere without a
 * word; now the step that hangs says so instead). The step itself is not cancelled.
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, step: string): Promise<T> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<never>((_, reject) => {
    timer = setTimeout(() => reject(new StepTimeoutError(step)), ms);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}
